import { LogLevel } from '@signage-player/contracts';
/**
 * Check if the given level is same or higher than the minimum level
 */
export function isSameOrHigherLevel(level, minimumLevel) {
    const levels = [LogLevel.DEBUG, LogLevel.INFO, LogLevel.NOTICE, LogLevel.WARNING, LogLevel.ERROR, LogLevel.CRITICAL, LogLevel.ALERT, LogLevel.EMERGENCY];
    const currentIndex = levels.indexOf(level);
    const minimumIndex = levels.indexOf(minimumLevel);
    return currentIndex >= minimumIndex;
}
/**
 * Abstract base logger class
 */
export class AbstractLogger {
    constructor(minimumLevel) {
        this.additionalContext = {};
        this.minimumLevel = minimumLevel;
    }
    emergency(message, context) {
        this.log(LogLevel.EMERGENCY, message, context);
    }
    alert(message, context) {
        this.log(LogLevel.ALERT, message, context);
    }
    critical(message, context) {
        this.log(LogLevel.CRITICAL, message, context);
    }
    error(message, context) {
        this.log(LogLevel.ERROR, message, context);
    }
    warning(message, context) {
        this.log(LogLevel.WARNING, message, context);
    }
    notice(message, context) {
        this.log(LogLevel.NOTICE, message, context);
    }
    info(message, context) {
        this.log(LogLevel.INFO, message, context);
    }
    debug(message, context) {
        this.log(LogLevel.DEBUG, message, context);
    }
    setAdditionalContext(context) {
        this.additionalContext = {
            ...this.additionalContext,
            ...context,
        };
    }
    getAdditionalContext() {
        return this.additionalContext;
    }
    /**
     * Clear context by removing all keys that start with __
     */
    clearContext(context) {
        if (context) {
            const newContext = {};
            Object.keys(context).forEach(key => {
                if (!key.startsWith('__')) {
                    newContext[key] = context[key];
                }
            });
            return newContext;
        }
        return undefined;
    }
}
//# sourceMappingURL=AbstractLogger.js.map